import { Checkbox } from "@chakra-ui/react";
import React from "react";
import { CheckboxProps } from "../ui/checkbox";

interface Props extends CheckboxProps {
  checked: boolean;
  label?: string | React.ReactNode;
  onChange: () => void;
}

export default function CustomCheckBox({ checked, label, onChange, ...props }: Props) {
  return (
    <Checkbox.Root checked={checked} onCheckedChange={onChange} {...props}>
      <Checkbox.HiddenInput />
      <Checkbox.Control />
      {label && <Checkbox.Label>{label}</Checkbox.Label>}
    </Checkbox.Root>
  );
}
